import { useState } from 'react';
import { useCashFundPartnerPlacement } from '@shared/hooks/useCashFundPartnerPlacement/useCashFundPartnerPlacement';

/** Keep the selected payout flow stable for an open dialog and defer the first Mercury mount. */
export const useTransferSheetRollout = (isOpen: boolean, canManagePayouts: boolean, isReadyToUse: boolean) => {
  const options = { skip: !canManagePayouts };
  const transfer = useCashFundPartnerPlacement('transferToBank', options);
  const repeat = useCashFundPartnerPlacement('transferToBankRepeat', options);
  const { partner, loading } = isReadyToUse ? repeat : transfer;
  const eligible = canManagePayouts && !loading && partner === 'mercury';
  const [session, setSession] = useState({ isOpen, enabled: eligible, hasOpenedMercury: isOpen && eligible });

  // Capture on the opening render, before children commit. Later flag responses apply next time.
  if (session.isOpen !== isOpen) {
    setSession({ isOpen, enabled: eligible, hasOpenedMercury: session.hasOpenedMercury || (isOpen && eligible) });
  }

  return {
    transferSheetEnabled: canManagePayouts && (isOpen ? session.enabled : eligible),
    // Keep it mounted after the first open so its close/reset lifecycle can finish.
    shouldMountTransferSheet: session.hasOpenedMercury,
  };
};
